import { getSafePropertyChain } from '@empathy/get-safe-property-chain';
import { ResponseTransformed } from '@empathy/search-adapter';

export const mapBlogPostHook: ResponseTransformed = ({ response, rawResponse }) => {
  const rawBlogResults = getSafePropertyChain(rawResponse, 'blog.docs', []);
  Object.assign(response, {
    blogPosts: rawBlogResults.map((rawBlogResult) => ({
        id: rawBlogResult.id,
        name: rawBlogResult.name,
        url: rawBlogResult.url,
        image: rawBlogResult.image
      }
    ))
  });
};
